import {
    // BaseInput,
    BaseDropdown,
    // BaseButton,
    // BaseTable,
} from "../components";

const GlobalComponents = {
    install(Vue) {
        // Vue.component(BaseInput.name, BaseInput);
        Vue.component(BaseDropdown.name, BaseDropdown);
        // Vue.component(BaseButton.name, BaseButton);
        // Vue.component(BaseTable.name, BaseTable);
    }
};

export default GlobalComponents;